import { render } from "./TwitchCallback.vue?vue&type=template&id=494c1344&scoped=true"
import script from "./TwitchCallback.vue?vue&type=script&lang=js"
export * from "./TwitchCallback.vue?vue&type=script&lang=js"

import "./TwitchCallback.vue?vue&type=style&index=0&id=494c1344&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-494c1344"]])

export default __exports__